export default "__VITE_ASSET__BDGZs$w8__"